import { api } from './api.js'

export type StanPowiadomien =
  | 'niedostepne'
  | 'wylaczone-na-serwerze'
  | 'odmowa'
  | 'wlaczone'
  | 'gotowe-do-wlaczenia'

interface KluczSerwera {
  wlaczone: boolean
  klucz: string | null
}

/** Klucz VAPID przychodzi w base64url, a `PushManager` chce surowych bajtów. */
function naBajty(base64url: string): ArrayBuffer {
  const dopelnienie = '='.repeat((4 - (base64url.length % 4)) % 4)
  const base64 = (base64url + dopelnienie).replace(/-/g, '+').replace(/_/g, '/')
  const surowe = window.atob(base64)
  const bufor = new ArrayBuffer(surowe.length)
  const bajty = new Uint8Array(bufor)
  for (let indeks = 0; indeks < surowe.length; indeks += 1) bajty[indeks] = surowe.charCodeAt(indeks)
  return bufor
}

function obslugiwane(): boolean {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window
}

export async function sprawdzPowiadomienia(): Promise<StanPowiadomien> {
  if (!obslugiwane()) return 'niedostepne'

  const konfiguracja = await api.get<KluczSerwera>('/api/push/klucz')
  if (!konfiguracja.wlaczone || konfiguracja.klucz === null) return 'wylaczone-na-serwerze'
  if (Notification.permission === 'denied') return 'odmowa'

  const rejestracja = await navigator.serviceWorker.getRegistration()
  const subskrypcja = await rejestracja?.pushManager.getSubscription()
  return subskrypcja === null || subskrypcja === undefined ? 'gotowe-do-wlaczenia' : 'wlaczone'
}

/**
 * Włącza przypomnienia na tym urządzeniu. Zgodę pytamy dopiero tutaj —
 * przy pierwszym wejściu do aplikacji byłaby natrętna i najczęściej odrzucona.
 */
export async function wlaczPowiadomienia(): Promise<StanPowiadomien> {
  if (!obslugiwane()) return 'niedostepne'

  const konfiguracja = await api.get<KluczSerwera>('/api/push/klucz')
  if (!konfiguracja.wlaczone || konfiguracja.klucz === null) return 'wylaczone-na-serwerze'

  const zgoda = await Notification.requestPermission()
  if (zgoda !== 'granted') return 'odmowa'

  const rejestracja = await navigator.serviceWorker.ready
  const subskrypcja = await rejestracja.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: naBajty(konfiguracja.klucz),
  })

  const dane = subskrypcja.toJSON() as { endpoint?: string; keys?: Record<string, string> }
  await api.post('/api/push/subskrypcja', {
    endpoint: dane.endpoint,
    keys: { p256dh: dane.keys?.p256dh, auth: dane.keys?.auth },
  })

  return 'wlaczone'
}

export async function wylaczPowiadomienia(): Promise<StanPowiadomien> {
  const rejestracja = await navigator.serviceWorker.getRegistration()
  const subskrypcja = await rejestracja?.pushManager.getSubscription()
  if (subskrypcja === null || subskrypcja === undefined) return 'gotowe-do-wlaczenia'

  await api.del(`/api/push/subskrypcja?endpoint=${encodeURIComponent(subskrypcja.endpoint)}`)
  await subskrypcja.unsubscribe()
  return 'gotowe-do-wlaczenia'
}
